/**
 * 创建人：但志强
 * 时间：2019-03-19
 * 描述：公共表格组件 可单选 复选 toolbar
 * 使用说明: 参考 sw-grid-table 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, ContentChild, TemplateRef, Output, EventEmitter, AfterViewInit, ViewChild, SimpleChanges, ElementRef } from '@angular/core';
import { SwToolbarComponent } from '../sw-toolbar/sw-toolbar.component';
import { SwPhotoAlbumService } from '../../sw-photo-album/sw-photo-album.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $: any;


/**
 * 公共表格组件 sw-grid-table 
 */
@Component({
  selector: 'sw-grid-table',
  templateUrl: './sw-grid-table.component.html',
  styleUrls: ['./sw-grid-table.component.css']
})

export class SwGridTableComponent implements OnInit, AfterViewInit {

  /**
   * 选中的索引
   * @ignore
   */
   @Input() selectedIndex: number[] = [];


   /**
   * 外层容器的overflow样式
   * @ignore
   */
   @Input() wrapBoxOverflow: string = 'auto';
  /**
   * 输入表格的数据
   */
  @Input() datas: any[] = [];

  /**
   * 展示分级的面包屑,其值为面包屑的数组值
   */
  @Input() crumbs:any[] = []

  /**
   * 展示分级的面包屑,其值为根据 crumbs 的哪个字段来显示面包屑,
   */
  @Input() crumbsKeyWord:string

  /**
   * 是否多选
   */
  @Input() multiple: Boolean = false;
  
  /**
    * 表格禁止选中的数据 {ids:[],name:''};  当选中数据的 name 属性的值为 ids 中某个值，就禁止
    */
  @Input() disabledDatas: any = {ids:[],name:''};

  /**
   * 工具栏数据
   */
  @Input() toolbars: any[] = [];

  /**
   * 启用关闭工具栏
   */
  @Input() initToolBar: boolean = true;

  /**
   * 通过手动传递uri 获取按钮
   */
  @Input() urlToolBar: string = "";

  /**
   * 开启九宫格模式
   */
  @Input() isThumbnail: boolean = false; 
   /**
   * 九宫格模式类型
   * 类型1 为左侧图片 右边文字类型 文字适合较短
   * 类型2 为左侧图片 右边文字 适合三条数据 类似 标题 时间 描述（内容可以较长）
   * 类型3 为图片 文字覆盖图片上 适合一条  文字适合标题类 较短
   * 类型4 为上下布局，上侧图片 下侧依次为文字类型 文字适合较短
   */
  @Input() ThumbnailType: number = 1;

  /**
   * ThumbOrder 为表格列添加的属性  ThumbOrder为img 则为展示的图片  若为1,2,3 则为展示顺序
   */
  /**
   * 九宫格图片是否异步加载
   */
  @Input() isThumbnailAsync: boolean = false;
  /**
   * 九宫格是否可以查看详情（鼠标移动，可查看数据详情）
   */
  @Input() isThumbDetail: boolean = false;
   /**
   * 九宫格可以查看详情时， 其对应的主键名称
   */
  @Input() thumbKey: string = '';
  /**
   * 九宫格鼠标悬浮可以查看详情时 是否可以点击 查看详情>> 事件
   */
  @Input() isThumbDetailClick: boolean = false;
  /**
   * 是否显示按钮工具栏sw-toolbar中 表格和九宫格切换的按钮 默认显示
   */
  @Input() isDisplayThumbBtn: boolean = true;
  /**
   * 当九宫格类型为业务端传入（即套用壳子），需要传入壳子类型，当为1时 代表class名为 thumbnail-box-1，依次类推 =>前提ThumbnailType的值为99
   */
  @Input() ThumbnailBoxType: number = 1;
  /**
   * 当九宫格类型为业务端传入（即套用壳子），可以自定义该九宫格壳子最外边一层div的class名称，即可以在原来壳子类型样式基础上，自己修改新样式
   */
  @Input() thumbnailClassName: string = '';
  /**
   * 输出选中的数据
   */
  @Output() selectData = new EventEmitter();

  /**
   * 按钮点击事件 返回 functionCode （点击按钮返回code 如： add）
   */
  @Output() operation = new EventEmitter(); 
   /**
   * 按钮点击事件  返回 target （按钮打开方式）
   */
  @Output() openType = new EventEmitter(); 

  /**
   * 双击事件
   */
  @Output() ondblclick = new EventEmitter();

  /**
   * 选择面包屑数据后抛出结果 {selectData:{} , newCrumbs:[]}  , selectData--要根据此值查询列表数据，  newCrumbs--列表查询完之后，将此值赋值给面包屑组件的 crumbs 参数
   */
  @Output() crumbsSelectData = new EventEmitter();

  /**
   * 九宫格对应元素点击事件
   */
  @Output() thumbClick = new EventEmitter();

  /**
   * 按钮组件
   * @ignore
   */
  @ViewChild("toolbar") toolbar: SwToolbarComponent;

  /**
   * 列标题
   * @ignore
   */
  @ContentChild('columnTitle') columnTitleTmpl: TemplateRef<any>;

  /**
   * 显示数据
   * @ignore
   */
  @ContentChild('cell') cellTmpl: TemplateRef<any>;

  /**
   * 子表格数据
   * @ignore
   */
  @ContentChild('detailTable') detailTableTmpl: TemplateRef<any>;
  /**
   * 九宫格数据（当九宫格选择壳子功能）
   */
  @ContentChild('thumbCell') thumbCellTmpl: TemplateRef<any>;
  /**
   * 
   */
  @ContentChild('thumbDetailCell') thumbDetailCellTmpl: TemplateRef<any>;
  /**
   * 表格的id
   * @ignore
   */
  idt: string;

  /**
   * 是否显示列表 宫格
   * @ignore
   */
  @Input() isDisplay: Boolean = true

   /**
   * 表格列表是否显示筛选功能
   * @ignore
   */
  @Input() isFilter: Boolean = false
   /**
   * 表格列表筛选checkbox判断
   * @ignore
   */
  @Input() filterDatas: any = {}
   /**
   * 表格列表筛选dropdown数据
   * @ignore
   */
  @Input() filterDatasArray: any = []

  /**
   * 抛出筛选后数据
   */
  @Output() filter = new EventEmitter();
  /**
   * 是否为空数据
   */
  @Input() isEmpty: boolean = false;

  /** 
   * 抛出toolBars的值（用于自定义表单判断新增修改查看打开方式）
  */
 @Output() toolbarData = new EventEmitter();

  /**
   * 是否正在加载中
   */
  @Input() isLoading: boolean = false;

  /**
   * 表格标题
   */
  @Input() tableHeader: string = '';

    /**
   * 是否显示表格表头
   */
  @Input() isTableTitle: boolean = true;

   /**
   * 表格中表头和表格td中字体居中、居左、居右的class值
   */
  @Input() textClass: string = 'left';

    /**
   * 表格数据是否排序 （非表头排序） toolbar下拉排序 功能
   */
  @Input() isOrder: boolean = false

  /**
   * orderNames 下拉排序对应字段值（和表格表头排序对应的columnname相同） 数组
   * {id:"",text:""} 
   */
  @Input() orderNames: any = [];  

  @Input() custom:boolean=false;

  @Input() customHeight:string='';

   /**
   * defaultOrderBy 下拉排序对应的默认选中值 字符串 格式类型为 't.' + orderName + ' ' + orderType
   * 业务端传入
   * t.role_name asc
   */
  @Input() defaultOrderBy:string = ""
   /**
   * 选中排序数据
   */
  @Output() order =  new EventEmitter();
  /**
   * 是否有统计按钮
   */
  @Input() isStatistic: boolean = false
   /**
   * 子按钮下拉的最大高度
   */
  @Input() dropMaxHeight: string = '140px';
   /**
   * toolbar最小高度
   */
  @Input() minHeight: string = '40px';
 /**
   * （九宫格模式下）grid-body 盒子是否有padding值  false有; true没有
   */
  @Input() withoutPadding: boolean = false;
  /**
   *系统配置按钮是否显示右边
   */
  @Input() isDefaultRight: boolean = false
  /**
   *是否显示表格行序列号
   */
  @Input() isShowTdIndex: boolean = true
  
  isAfterTime:boolean = false; //当为九宫格时  延迟时间后 将该变量值设置为true
  /**
   * @ignore
   */
  constructor(
    public popup: SwPhotoAlbumService, 
    private el: ElementRef,
    private box: SwMassageBoxService,
    ) { }

  /**
   * @ignore
   */
  ngOnDestroy(): void { }

  /**
   * @ignore
   */
  ngOnInit() {
    this.idt = "table" + Math.random().toString().split(".")[1];
  }

  /**
   * @ignore
   */
  ngAfterViewInit() {
    this.isAfterTime = false;
    if(!this.isDisplay){
      let time = 100;
      let datasLength = this.datas.length;
      if(this.datas &&  datasLength){
        if(this.isThumbnailAsync) {
          time = this.fetchTime(datasLength,time)
        }
        if (this.isThumbnail)
        setTimeout(() => {
          this.onClickDisplay(this.isDisplay)
        }, time)
       }
     
    }
  
   
  }

  /**
   * 当表格数据发生变换的时候
   * @ignore
   */
  overflowRes:string = 'auto'
  ngOnChanges(changes: SimpleChanges): void {
    let datasLength = 0
    let datas1= []
    let datasLength1 = 0
    this.isAfterTime = false;
    if(changes && changes['datas']) {
      if(changes['datas']['currentValue']){
        datas1 = [...changes['datas']['currentValue']]
      }
      datasLength1 = datas1.length;

      if(datasLength1 > 0) {
        this.isEmpty = false;
      }else {
        this.isEmpty = true;
      }
      //2022年5月31日12:16:04   这里判断是否空数据逻辑有问题?
      // if(changes['datas']['previousValue'] == undefined) {
      //   this.isEmpty = false; 
      // }else {
      //   if(datasLength1 > 0) {
      //     this.isEmpty = false;
      //   }else {
      //     this.isEmpty = true;
      //   }
      // }
     }
    
     if(changes && changes['toolbars']){
      //如果是工具栏按钮变化，就不用刷新选中数据
    } else {
      // debugger
       this.selectedIndex = [];

    }
    let time = 100;
   
    if(this.datas){
      datasLength = this.datas.length;
    }
    if(this.datas &&  datasLength){
      this.overflowRes = this.datas.length <=3 ? 'visible' : 'auto'  //div.card-body的overflow的设置,默认为auto,当数据只有一条时,设置为visible
      if(this.isThumbnailAsync) {
       time = this.fetchTime(datasLength,time)
      }
      if (this.isThumbnail)
      setTimeout(() => {
        this.onClickDisplay(this.isDisplay)
      }, time)
    }
  }

  /**
   * 根据表格datas数据数组长度判断time值
   * @param datasLength  传入datas长度
   * @param time  传入延迟的time值
   * @ignore
   */
  fetchTime(datasLength,time) {
    let times = time
    if(datasLength<=5) {
      times = 300
    }else if(datasLength>5 && datasLength <=10) {
      times = 500
    } else if(datasLength>10 && datasLength <=20) {
      times = 700
    }else if(datasLength>20 && datasLength <=30) {
      times = 900
    }else if(datasLength>30 && datasLength <=40) {
      times = 1100
    }else if(datasLength>40 && datasLength <=50) {
      times = 1300
    }else if(datasLength>50 && datasLength <=100) {
      times = 1500
    }
    return times
  }
  /**
   * 判断是否选中，加载表格选中样式
   * @param index  选中下标
   * @ignore
   */
  isSelected(index: number) {
    return this.selectedIndex.indexOf(index) > -1;
  }

  /**
   * 判断是否全选
   * @ignore
   */
  isSelectedAll() {
    //看列表中有几个可以被选中，如果可以被选中的数量和已经选中的数量一致，就说明已经全选了，那么点击复选框是要做反选操作
    if(this.datas){
      let canCheck = this.datas.length
      this.datas.forEach(v=>{
        if(this.disabledDatas.name && this.disabledDatas.ids.includes(v[this.disabledDatas.name])){
          canCheck--
        }
      })
      
      if (this.datas && this.datas.length!=0)
        return canCheck == this.selectedIndex.length;

    }
    return false;
  }

  /**
   * 判断是否禁止选中全选（多选情况下）
   * @param index 
   * @param data 
   */
  isDisabledAll(index:number,data){
    if(this.datas){
      let canCheck = this.datas.length
      this.datas.forEach(v=>{
        if(this.disabledDatas.name && this.disabledDatas.ids.includes(v[this.disabledDatas.name])){
          canCheck--
        }
      })
      return canCheck == 0;
    }
    return true;
  }


  /**
   * 判断是否禁止选中（多选情况下）
   * @param index 
   * @param data 
   */
  isDisabled(index:number,data){
    if(this.disabledDatas.ids.length)
      return this.disabledDatas.ids.includes(data[this.disabledDatas.name])
  }

  /**
   * 点击选中事件
   * @param index 选中下标
   * @ignore 
   */
  onSelect(index: number) {
    //如果点击的数据试禁止的数据，就不做选中操作
    let data = this.datas[index]
    if(this.disabledDatas.name && this.disabledDatas.ids.includes(data[this.disabledDatas.name])){
      this.box.danger('此数据禁止选中')
      return
    }

    //判断是否多选
    if (!this.multiple) {
      if (this.selectedIndex[0] == index) {
        this.selectedIndex = [];
      } else {
        this.selectedIndex[0] = index;
      }
    } else {
      //单选点击
      let position = this.selectedIndex.indexOf(index);
      if (position > -1) {
        this.selectedIndex.splice(position, 1)
      } else {
        this.selectedIndex.push(index);
      }
    }
    //传递点击事件
    this.outSelectData();
  }
  /**
   * 双击选中事件
   * @param index 选中下标
   * @ignore 
   */
  onDblClick(index: number){
    this.ondblclick.emit( this.datas[index]);
  }

  /**
   * 全选事件
   * @ignore
   */
  onSelectAll() {
    if (!this.isSelectedAll()) {
      this.selectedIndex = [];
      for (let i = 0; i < this.datas.length; i++) {
        //将非禁止的数据都选中
        if(this.disabledDatas.name && this.disabledDatas.ids.includes(this.datas[i][this.disabledDatas.name])){
          //此为禁止选中数据
        } else{
          this.selectedIndex.push(i);
        }
      }
    } else {
      this.selectedIndex = [];
    }
    this.outSelectData();
  }

  /**
   * 获取选中数据
   */
  getDate() {
    if (this.multiple) {
      let item = [];
      for (let i of this.selectedIndex)
        item.push(this.datas[i])
      return item;
    } else {
      if (this.selectedIndex.length > 0)
        return this.datas[this.selectedIndex[0]];
      return null;
    }
  }

  /**
   * 输出点击的数据
   * @ignore
   */
  outSelectData() {
    if (this.multiple) {
      let item = [];
      for (let i of this.selectedIndex) {
        item.push(this.datas[i])
      }
      this.selectData.emit(item);
    } else {
      if (this.selectedIndex.length > 0)
        this.selectData.emit(this.datas[this.selectedIndex[0]]);
      else {
        this.selectData.emit({});
      }
    }
  }

  /**
   * 启用全部按钮
   */
  toolbarAllEnable() {
    this.toolbar.toolbarAllEnable();
  }
  /**
   * 启用单个按钮
   * @param type 按钮code
   */
  toolbarEnable(type: string) {
    this.toolbar.toolbarEnable(type);
  }
  /**
   * 禁用全部按钮
   */
  toolbarAllDisable() {
    this.toolbar.toolbarAllDisable();
  }
  /**
   * 禁用单个按钮
   * @param type 按钮code
   */
  toolbarDisable(type: string) {
    this.toolbar.toolbarDisable(type);
  }

  /**
   * 禁用按钮
   * @param type 如果输入all 则禁用全部 
   */
  disableToolbar(type: string) {
    if (type !== "all")
      this.toolbar.toolbarDisable(type);
    else
      this.toolbar.toolbarAllDisable();
  }
  /**
   * 启用按钮
   * @param type  如果输入all 则启用全部
   */
  enableToobar(type: string) {
    if (type !== "all")
      this.toolbar.toolbarEnable(type);
    else
      this.toolbar.toolbarAllEnable();
  }

  //显示隐藏按钮
    /**
   * 显示全部按钮
   */
  toolbarAllShow() {
    this.toolbar.toolbarAllShow();
  }
  /**
   * 显示单个按钮
   * @param type 按钮code
   */
  toolbarShow(type: string) {
    this.toolbar.toolbarShow(type);
  }
  /**
   * 隐藏全部按钮
   */
  toolbarAllHide() {
    this.toolbar.toolbarAllHide();
  }
  /**
   * 隐藏单个按钮
   * @param type 按钮code
   */
  toolbarHide(type: string) {
    this.toolbar.toolbarHide(type);
  }

  /**
   * 隐藏按钮
   * @param type 如果输入all 则隐藏全部 
   */
  hideToolbar(type: string) {
    if (type !== "all")
      this.toolbar.toolbarHide(type);
    else
      this.toolbar.toolbarAllHide();
  }
  /**
   * 显示按钮
   * @param type  如果输入all 则显示全部
   */
  showToobar(type: string) {
    if (type !== "all")
      this.toolbar.toolbarShow(type);
    else
      this.toolbar.toolbarAllShow();
  }

  

  /**
   * 清空选中
   * @ignore
   */
  clearSelect() {
    this.selectedIndex = [];
  }

  /**
   * 通过主键选中行数据 单一
   * @param id  选中的主键
   * @param idName  主键的名称
   */
  selectTable(id: string, idName: string) {
    if (!this.multiple)
      this.selectedIndex = []
    this.selectedIndex.push(this.datas.findIndex(x => x[idName] == id))
    this.outSelectData();
  }

  /**
   * 通过主键选中行数据 多选
   * @param ids  选中的主键
   * @param idName  主键的名称
   */
  selectTableArray(ids: Array<string>, idName: string) {
    if (!this.multiple)
      this.selectedIndex = []

    ids.forEach(el => {
      this.selectedIndex.push(this.datas.findIndex(x => x[idName] == el))
    })
    this.outSelectData();
  }

  /**
   * 切换九宫格 列表触发事件
   * @param br true 或者false
   * @ignore
   */
  onClickDisplay(br) {
    this.isDisplay = br
    this.isAfterTime = true;
    //当为九宫格，但不是为业务端传过来的九宫格
    if(this.ThumbnailType != 99){
      this.clickDisplay(this.isDisplay)
    }
  }

  /**
   * 保存所有的title
   * @ignore
   */
  titlesDiv = []

  /**
   * 保存所有显示的数据
   * @ignore
   */
  datasDiv = []

  /**
   *（九宫格） 保存所有的要展示详情的对应的表头 title
   * @ignore 
   */
  titleDetailDiv = []
  /**
   *（九宫格） 保存所有的要展示详情的对应的数据 
   * @ignore 
   */
  datasDetailDiv = []
  /**
   * 转换九宫格模式
   * @param br  是否开启九宫格  
   * @ignore
   */
  clickDisplay(br) {
    this.isDisplay = br
    if (!br) {
      this.titlesDiv = [] //清空titl
      this.datasDiv = [] //清空显示的数据
      this.titleDetailDiv = [] //清空所有的要展示详情的对应的表头
      this.datasDetailDiv = [] //清空所有的要展示详情的对应的数据 
      //1.获取标题
      let childrenTr = $("#" + this.idt + " tr ") //获取所有的tr 数据
      if (!childrenTr[0]) return;
      let children = $("#" + this.idt + " tr ")[0].children //获取title数据
      let i = 1; //忽略前面几个td 第一个是下标 多选多加一个
      // if (this.multiple) //判断是不是多选
      //   i++;
      //循环拿到所有的 title 数据 
      for (let j = 0; children.length > j; j++) {
        //循环表头  获取含有属性为ThumbOrder的表头 (ThumbOrder属性存在 代表为九宫格需要展示的一个字段)
        let ThumbOrder = children[j].getAttribute('ThumbOrder');
        //循环表头 获取含有属性为ThumbWithImg的表头(ThumbWithImg属性存在且为true 代表为该表头对应的td中不仅含有文字，标签等还含有要展示的图片)
        let ThumbWithImg = children[j].getAttribute('ThumbWithImg');
        //循环表头 获取含有属性为ThumbWithClick的表头(ThumbWithClick属性存在且为true 代表该表头对应的td中含有click事件)
        let ThumbWithClick = children[j].getAttribute('ThumbWithClick');
        //若ThumbOrder属性存在 将该th在tr的下标值 、innerText内容 、ThumbOrder属性值和children值输入数组titlesDiv中
        if (ThumbOrder) {
          let titObj = { index: j, Text: children[j].innerText, ThumbOrder: ThumbOrder, childre: [], ThumbWithImg: false,ThumbWithClick: false}
          //若该表头的属性ThumbWithImg存在且为true
          if(ThumbWithImg){
            titObj.ThumbWithImg = true
          }
          //若该表头的属性ThumbWithClick存在且为true
          if(ThumbWithClick){
            titObj.ThumbWithClick = true
          }
          this.titlesDiv.push(titObj)
        }
        //循环表头 获取含有属性为ThumbDetailOrder的表头（ThumbDetailOrder属性存在 代表九宫格需要展示详情信息的一个字段）
        let ThumbDetailOrder = children[j].getAttribute('ThumbDetailOrder');
        //若ThumbDetail属性存在 
        if(ThumbDetailOrder){
           let detailObj = { index: j, Text: children[j].innerText, ThumbDetailOrder: ThumbDetailOrder, childre: []}
           this.titleDetailDiv.push(detailObj)
        }
      }
      //判断表头是九宫格的数组是否含有img（即ThumbOrder的值是否有img或者是否有含有图片的td,即ThumbWithImg = true,是否有图片,若没有图片，加入一个默认图片信息）
      if(this.titlesDiv.filter(x=>x.ThumbOrder ==  'img' || x.ThumbWithImg == true).length<=0){
        this.titlesDiv.push({ index:1, Text: "缩略图", ThumbOrder:"img", childre: [], ThumbWithImg: false ,ThumbWithClick: false})
      };
      
      //j为0 代表的是表头的一行信息，当前j为1开始， 代表循环childrenTr除了表头的其他tr(tr中td的信息根据循环表头数组titlesDiv，获取相对应的九宫格信息)的信息
      for (let j = 1; childrenTr.length > j; ++j) {
        let classNames = childrenTr.eq(j).attr('class')
        let item = []
        //循环需要是九宫格的表头信息
        for (let i = 0; this.titlesDiv.length > i; ++i) {
          //获取一条九宫格的表头信息对象
          let obj = { index: this.titlesDiv[i].index, Text: this.titlesDiv[i].Text, ThumbOrder: this.titlesDiv[i].ThumbOrder, data: "", details:'' ,ThumbWithClick:this.titlesDiv[i].ThumbWithClick};
          //若当前titlesDiv[i]的ThumbOrder值为img =>两种情况 判断当前表格行的数据中对应的td的image标签的src值  1.若有值 则obj的data值为获取的图片路径  2.若无值 则obj的data值为默认路径
          if (this.titlesDiv[i].ThumbOrder == 'img') {
            obj.ThumbWithClick = false
            if(classNames.indexOf('empty-tr') < 0){
              if (childrenTr[j].children[this.titlesDiv[i].index].children[0]) {
                obj.data = childrenTr[j].children[this.titlesDiv[i].index].children[0].getAttribute("src")
              }else {
                obj.data = "/assets/Theme/default/img/no-pic.png"
              }
                
            }
          } else {
              //获取当前tr的class
              let className = childrenTr.eq(j).attr('class')
            //若当前titlesDiv[i]的ThumbOrder值不为img 但需要展示含有文字和图片的td中的图片，其ThumbWithImg为true
             if(this.titlesDiv[i].ThumbWithImg){
               let withImgObj = { index: this.titlesDiv[i].index, Text: "缩略图", ThumbOrder: "img", data: "", details:'' ,ThumbWithClick: false};
               //判断当前tr是否为空图片的tr
               if(className.indexOf('empty-tr') < 0){
                  //寻找当前tr下的对应td中标签image的src值
                  withImgObj.data =  childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).find("img")[0].src
                  item.push(withImgObj)
               }
             }
            //若当前titlesDiv[i]的ThumbOrder值不为img 为其他标签 则需要获取其标签内的值 有三种情况 1.标签为a标签 2.标签为span标签 3.标签为其他标签
            //1.标签为a标签 获取a标签值
            if(childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).find('a').html()) {
              let da = childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).find("a").html()
              //如果该标签有点击事件
              if(this.titlesDiv[i].ThumbWithClick){
                obj.data = '<a>'+ da+'</a>'
              }else {
                obj.data =  da
              }
            }else if(childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).find('span').html()){
              //2.标签为span标签 获取span标签值 和 class值
              let spanClass = childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).find('span').attr('class')
              obj.data ='<span class="'+spanClass+'">'+ childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).find('span').html()+'</span>'
            }else {
              //2.标签为其他标签 获取其标签值
              obj.data = childrenTr.eq(j).find('td').eq(this.titlesDiv[i].index).html() 
            }
            //获取其innerText 赋值给details（九宫格标签中title值）
            if(className.indexOf('empty-tr') < 0){
              obj.details =  childrenTr[j].children[this.titlesDiv[i].index].innerText
            }
          }
          item.push(obj)
        }
        //将表格每行需要展示到九宫格的数据数组追加到数组datasDiv內
        this.datasDiv.push(item);
        /////////// 以下为获取详情信息的方法
        let detailItem = []
        //循环需要是九宫格的表头信息
        for (let i = 0; this.titleDetailDiv.length > i; ++i) {
            //获取一条九宫格的表头详情信息对象
            let obj = { index: this.titleDetailDiv[i].index, Text: this.titleDetailDiv[i].Text, ThumbDetailOrder: this.titleDetailDiv[i].ThumbDetailOrder, data: "", details:''};
            //获取当前tr的class
            let className = childrenTr.eq(j).attr('class')
            //若当前titleDetailDiv[i]的ThumbDetailOrder值不为img 为其他标签 则需要获取其标签内的值 有三种情况 1.标签为a标签 2.标签为span标签 3.标签为其他标签
            //1.标签为a标签 获取a标签值
            if(childrenTr.eq(j).find('td').eq(this.titleDetailDiv[i].index).find('a').html()) {
              let da = childrenTr.eq(j).find('td').eq(this.titleDetailDiv[i].index).find("a").html()
              obj.data =  da
            }else if(childrenTr.eq(j).find('td').eq(this.titleDetailDiv[i].index).find('span').html()){
              //2.标签为span标签 获取span标签值 和 class值
              let spanClass = childrenTr.eq(j).find('td').eq(this.titleDetailDiv[i].index).find('span').attr('class')
              obj.data ='<span class="'+spanClass+'">'+ childrenTr.eq(j).find('td').eq(this.titleDetailDiv[i].index).find('span').html()+'</span>'
            }else {
              //2.标签为其他标签 获取其标签值
              obj.data = childrenTr.eq(j).find('td').eq(this.titleDetailDiv[i].index).html() 
            }
            //获取其innerText 赋值给details（九宫格标签中title值）
            if(className.indexOf('empty-tr') < 0){
              obj.details =  childrenTr[j].children[this.titleDetailDiv[i].index].innerText
            }
            detailItem.push(obj) 
        }
         //将表格每行需要展示到九宫格的详情数据数组追加到数组datasDiv內
         this.datasDetailDiv.push(detailItem);
      }
      //根据ThumbOrder的值的大小排序
      this.datasDiv.forEach(item => {
        item = item.sort((a, b) => {
          if (a.ThumbOrder === "img") {
            return -1
          }else if(b.ThumbOrder === "img"){
            return 1
          } else {
            return parseInt(a.ThumbOrder) > parseInt(b.ThumbOrder) ? 1 : parseInt(a.ThumbOrder) == parseInt(b.ThumbOrder) ? 0 : -1;
          }
        })
      })
      //整合数据
      //根据ThumbDetailOrder的值的大小排序
      this.datasDetailDiv.forEach(item => {
        item = item.sort((a, b) => {
          if (a.ThumbDetailOrder === "img") {
            return -1
          }else if(b.ThumbDetailOrder === "img"){
            return 1
          } else {
            return parseInt(a.ThumbDetailOrder) > parseInt(b.ThumbDetailOrder) ? 1 : parseInt(a.ThumbDetailOrder) == parseInt(b.ThumbDetailOrder) ? 0 : -1;
          }
        })
      })
     
    }
  }

  //图片预览
  expression(item) {
    event.stopPropagation()
    let fileSuffix = item.slice(item.length - 3, item.length).toLocaleLowerCase();
    if (fileSuffix.toLocaleLowerCase() == 'jpg' || fileSuffix.toLocaleLowerCase() == 'jpeg' || fileSuffix.toLocaleLowerCase() == 'png' || fileSuffix.toLocaleLowerCase() == 'bmp' || fileSuffix.toLocaleLowerCase() == 'gif') {
      let photosData = { path: [item], index: 0 };
      this.popup.showPhotoAlbum(photosData);
    } else {
      window.location.href = item;
    }
  }

  //字符串缩略
  mergeString(title) {
    if(title) {
    return title.Text+":"+ title.data
    }
   
  }
  //禁止冒泡
  stoppropagation($event) {
    $event.stopPropagation()
  }
  //点击九宫格数据 抛出事件
  clickThumb(trIndex,tdIndex,IfThumbWithClick,IfThumnDetailWithClick) {
    //event.stopPropagation()
    //IfThumbWithClick 为true 表示该字段有点击事件
      if(IfThumbWithClick){
        let obj = {
          trIndex:trIndex,
          tdIndex:tdIndex,
          idt: this.idt,
          isDetailClick:false
        }
        this.thumbClick.emit(obj)
      }
      if(IfThumnDetailWithClick){
        let obj = {
          trIndex:trIndex,
          tdIndex:tdIndex,
          idt: this.idt,
          isDetailClick:true
        }
        this.thumbClick.emit(obj)
      }

  }

   //鼠标移入事件 创建组件
   mouseover(event, thumbKey) {
    event.stopPropagation();
    if (this.isThumbDetail) {
      $('#'+this.idt + thumbKey).show()
      let postion = this.el.nativeElement.querySelector('#'+this.idt + thumbKey).parentNode.getBoundingClientRect()
      let w = $(window).width()
      let cha = w-postion.right
     
      if(cha > 210){
        this.el.nativeElement.querySelector('#'+this.idt + thumbKey).style.left = postion.right + 'px'
        this.el.nativeElement.querySelector('#'+this.idt + thumbKey).style.top = postion.top + 'px'
      }else {
        this.el.nativeElement.querySelector('#'+this.idt + thumbKey).style.left = postion.left-210 + 'px'
        this.el.nativeElement.querySelector('#'+this.idt + thumbKey).style.top = postion.top + 'px'
      }
     
    }

  }
  mousewheel(event, thumbKey) {
    event.stopPropagation();
    if (this.isThumbDetail) {
      $('#'+this.idt + thumbKey).hide()
    }
  }

  //鼠标移出事件 销毁组件
  mouseout(event, thumbKey) {
    event.stopPropagation();
    if (this.isThumbDetail) {
      $('#'+this.idt + thumbKey).hide()
    }
  }
  crumbsSelect(event){
    this.crumbsSelectData.emit(event)
  }

}
